<template>
  <section v-if="form || isEditing" class="container my-spacing-lg">
    
<FormKitLazyProvider config-file="true">
<FormKit
      v-if="form"
      type="form"
      :action="form.action"
      method="post"
      target="_blank"
      submit-label="Anmelden"
      :submit-attrs="{ name: 'subscribe' }"
    >
      <FormKit
        type="email"
        label="E-Mail Adresse"
        :name="form.inputMapping.email"
        validation="required|email"
      />
      <FormKit
        type="text"
        label="Vorname"
        :name="form.inputMapping.firstName"
      />
      <FormKit
        type="text"
        label="Nachname"
        :name="form.inputMapping.lastName"
      />

      <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
      <div aria-hidden="true" class="absolute left-[-5000px]">
        <FormKit type="text" :name="form.inputMapping.antiBot" />
      </div>
    </FormKit>
    <div v-else-if="isEditing">
      The Mailchimp signup form is not available on this domain.
    </div>
</FormKitLazyProvider>

  </section>
</template>

<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import { DomainId } from '#graphql-operations'

const { isEditing } = defineBlokkliFragment({
  name: 'mailchimp_signup_form',
  label: 'Mailchimp Signup Form',
  description: 'Zeigt das Anmeldeformular für Mailchimp Newsletter an.',
  chunkName: 'rare',
  editor: {
    noPreview: true,
  },
})

const { activeDomain } = useSiteContext()

type MailchimpForm = {
  action: string
  inputMapping: {
    email: string
    firstName: string
    lastName: string
    antiBot: string
  }
}

function getForm(): MailchimpForm | null {
  if (activeDomain === DomainId.eyz) {
    return {
      action:
        'https://swiss.us19.list-manage.com/subscribe/post?u=b83c088e57c6417390553f198&amp;id=7c22304629',
      inputMapping: {
        email: 'EMAIL',
        firstName: 'FNAME',
        lastName: 'LNAME',
        antiBot: 'b_b83c088e57c6417390553f198_7c22304629',
      },
    }
  } else if (activeDomain === DomainId.rapperswil_zuerichsee_ch) {
    return {
      action:
        'https://rapperswil-zuerichsee.us8.list-manage.com/subscribe/post?u=5c00661caded0a4210e6f9bba&amp;id=9ab0543ab0&amp;f_id=009273e0f0',
      inputMapping: {
        email: 'EMAIL',
        firstName: 'MMERGE16',
        lastName: 'MMERGE29',
        antiBot: 'b_5c00661caded0a4210e6f9bba_9ab0543ab0',
      },
    }
  }

  return null
}

const form = getForm()
</script>
